import { useQuery } from "@tanstack/react-query";
import { DailyForecast } from "../types/weatherForecast";
import { WeatherForecastApi } from "../types/weatherForecastApi";
import { isError } from "../utilities/typeguards";
import { mapWeatherApiData } from "../utilities/weatherHelpers";
import { baseFetch, HttpVerbs } from "./baseFetch";
import { endpoints } from "./endpoints";

type WeatherServiceParams = {
  location: string;
  searchPeriod: { from: string; to: string };
};

const fetchWeather = async (
  params: WeatherServiceParams
): Promise<DailyForecast[]> => {
  const url = `${endpoints.weatherTimeline}/${params.location}/${params.searchPeriod.from}/${params.searchPeriod.to}?unitGroup=uk&include=days,hours,alerts&code=${process.env.REACT_APP_WEATHERTIMELINE}`;
 
  const response = await baseFetch<WeatherForecastApi>({
    endpointUrl: url,
    httpVerb: HttpVerbs.GET
  });
  console.log("response", response);
  if (isError(response)) {
    throw new Error(`Error fetching weather data: ${response.message}`);
  }

  return mapWeatherApiData(response);
};

const useWeatherQuery = (params: WeatherServiceParams) => {
  return useQuery({
    queryKey: [
      "weather",
      params.location,
      params.searchPeriod.from,
      params.searchPeriod.to,
    ],
    queryFn: () =>
      fetchWeather({
        location: params.location,
        searchPeriod: params.searchPeriod,
      }),
    // Consider data fresh for 5 minutes
    staleTime: 5 * 60 * 1000,
    // Keep unused data in cache for 30 minutes
    gcTime: 30 * 60 * 1000,
  });
};

export { fetchWeather, useWeatherQuery };
export type { WeatherServiceParams };

